export default __webpack_public_path__ + "static/20-sitzer-3-22beb2febde7702e0bcd8b3621865fd5.jpg";